import React, { useState, useContext, useEffect } from 'react'
import { Layout, Menu } from 'antd';
import { buildMenuItems } from "../../utils";
import { protectedRoutes, protectedRoutesPrefix } from "../../routers/routes";
import GlobalStateContext from '../../context';
import logo from "../../assets/images/logo_transparent_cut_landscape.png";
import { Link, useLocation } from 'react-router-dom';
import Subscribe, { SubscribeButton } from './Subscribe';
import { ChevronLeft, ChevronRight, Home, Calendar, Globe, Settings, Crown } from 'lucide-react';

const { Sider } = Layout;

export default function Sidebar({ hidden }) {
  const [gState, dispatch] = useContext(GlobalStateContext)
  const { configuration } = gState;
  const [state, setState] = useState({
    collapsed: false,
  });
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  const location = useLocation();

  const onCollapse = collapsed => {
    setState({ collapsed });
    dispatch({
      type: 'SET_ITEM',
      payload: ['collapsed_nav', collapsed]
    })
  };

  useEffect(() => {
    onCollapse(false) // Start expanded by default
  }, [])

  const handleUpgradeClick = () => {
    console.log('handleUpgradeClick')
    setShowSubscribeModal(true);
  };

  const handleCloseSubscribe = () => {
    setShowSubscribeModal(false);
  };

  // Custom navigation items with icons
  const navigationItems = [
    {
      key: `/app`,
      icon: <Home className="w-5 h-5" />,
      label: 'Dashboard',
      path: `/app`
    },
    {
      key: `/app/events`,
      icon: <Calendar className="w-5 h-5" />,
      label: 'Events',
      path: `/app/events`
    },
    {
      key: `/app/destinations`,
      icon: <Globe className="w-5 h-5" />,
      label: 'Destinations',
      path: `/app/destinations`
    },
    {
      key: `/app/account`,
      icon: <Settings className="w-5 h-5" />,
      label: 'Account',
      path: `/app/account`
    }
  ];

  return (
    <Sider
      theme="light"
      collapsible
      collapsed={state.collapsed}
      onCollapse={onCollapse}
      width={256}
      collapsedWidth={80}
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
        zIndex: 1000,
        borderRight: '1px solid #e5e7eb'
      }}
      hidden={hidden}
    >
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="px-4 py-4 my-1">
          <div className="flex items-center justify-center">
            {!state.collapsed && (
              <Link to={`/${protectedRoutesPrefix}`} className="flex items-center">
                <img
                  alt="Viblica Logo"
                  className="h-8 w-auto"
                  src={logo}
                />
              </Link>
            )}
            {state.collapsed && (
              <Link to={`/${protectedRoutesPrefix}`} className="flex items-center">
                <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-sm">V</span>
                </div>
              </Link>
            )}
          </div>
        </div>
      </div>

      {/* Navigation */}
      <div className="flex-1 px-3 py-2 bg-white">
        <nav className="space-y-1">
          {navigationItems.map((item) => (
            <Link
              key={item.key}
              to={item.path}
              className={`flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${location.pathname === item.key
                ? 'bg-blue-50 text-blue-700 border-l-4 border-blue-600 shadow-sm'
                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`}
            >
              <div className={`${state.collapsed ? 'mr-0' : 'mr-3'} flex-shrink-0`}>
                {React.cloneElement(item.icon, {
                  className: `w-5 h-5 ${location.pathname === item.key ? 'text-blue-600' : 'text-gray-400'
                    }`
                })}
              </div>
              {!state.collapsed && (
                <span className="truncate">{item.label}</span>
              )}
            </Link>
          ))}
        </nav>
      </div>

      {/* Upgrade Section - Only show if user doesn't have an active package */}
      {!gState.user?.active_subscription && (
        <div className="p-3 border-t border-gray-200 bg-white">
          {!state.collapsed ? (
            <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg p-3 text-white shadow-lg">
              <div className="flex items-center mb-2">
                <Crown className="w-5 h-5 mr-2 text-yellow-300" />
                <span className="font-semibold text-sm">Upgrade Plan</span>
              </div>
              <p className="text-xs text-blue-100 mb-3 leading-relaxed">
                Unlock premium features and get unlimited streaming
              </p>
              <SubscribeButton />
            </div>
          ) : (
            <div className="flex justify-center">
              <button
                onClick={handleUpgradeClick}
                className="p-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-200 shadow-md"
              >
                <Crown className="w-5 h-5 text-yellow-300" />
              </button>
            </div>
          )}
        </div>
      )}
    </Sider>
  )
}
